import React from 'react';
import { Result, Button } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';

const Logout = () => {
  return (
    <Result
      status="success"
      title="您已成功登出！"
      subTitle="您可以安心關閉視窗"
      extra={[
        <Button
          icon={<ArrowRightOutlined />}
          onClick={() => (window.location.href = '/home')}>
          重新登入
        </Button>,
      ]}
    />
  );
};

export default Logout;
